"use client";

import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { Icon } from "@/shared/ui/atoms";
import useDataStore from "@/features/home/model/data/store";
import { useTranslations } from "next-intl";
import { TREATMENTS_IMAGES } from "@/shared/constants/treatments";
interface TreatmentsInterestSelectButtonProps {
  treatmentKey: string;
  width: number;
  height: number;
}
const TreatmentsInterestSelectButton = t0 => {
  const $ = _c(22);
  const {
    treatmentKey,
    width,
    height
  } = t0;
  const t = useTranslations();
  const {
    interestTreatment,
    setInterestTreatment
  } = useDataStore();
  const isSelected = interestTreatment.includes(treatmentKey);
  const selectImage = TREATMENTS_IMAGES.select[treatmentKey as keyof typeof TREATMENTS_IMAGES.select];
  const deselectImage = TREATMENTS_IMAGES.deselect[treatmentKey as keyof typeof TREATMENTS_IMAGES.deselect];
  let t1;
  if ($[0] !== t || $[1] !== treatmentKey) {
    t1 = t.raw(`commonMedicalTreatment.treatments.${treatmentKey}`);
    $[0] = t;
    $[1] = treatmentKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const name = t1 as string;
  const t2 = `w-full min-h-[160px] flex items-center justify-center rounded-lg ${isSelected ? "bg-[#F6F2FF]" : "bg-[#F5F5F5]"}`;
  let t3;
  if ($[3] !== setInterestTreatment || $[4] !== treatmentKey) {
    t3 = () => setInterestTreatment(treatmentKey);
    $[3] = setInterestTreatment;
    $[4] = treatmentKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `mt-3 flex items-center justify-center w-[80px] h-[80px] rounded-full ${isSelected ? "bg-primary-600" : "bg-white"}`;
  const t5 = isSelected ? selectImage : deselectImage;
  let t6;
  if ($[6] !== height || $[7] !== t5 || $[8] !== width) {
    t6 = <Icon src={t5} alt="12" width={width} height={height} />;
    $[6] = height;
    $[7] = t5;
    $[8] = width;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== name) {
    t8 = <Typography size={18} lineHeight={26}>{name}</Typography>;
    $[13] = name;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t7 || $[17] !== t8) {
    t9 = <CustomButton className="flex flex-col gap-3 items-center justify-center" onClick={t3}>{t7}{t8}</CustomButton>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t9) {
    t10 = <div className={t2}>{t9}</div>;
    $[19] = t2;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default TreatmentsInterestSelectButton;